import React, { useMemo } from 'react';
import { CtaButton } from '@/components/Cta/Cta';
import { useCustomerContext } from '@/lib/customer/CustomerContext';
import { isValidEmail as _isValidEmail } from '@/lib/isValidEmail';
import { AUTH_STEPS } from '../../constants';
import { StepProps } from '../types';
import i18n from '@/settings/i18n';

const t = i18n.init('auth');

const EmailStep = ({ setStep, data, setData }: StepProps) => {
  const { cognitoLogin, loading } = useCustomerContext();

  const isValidEmail = useMemo(() => _isValidEmail(data.email), [data.email]);

  // Anti-enumeration: never reveal whether an account exists. Trigger a
  // background backfill, then always advance to the password screen; any
  // email x password failure is reported generically there.
  const onContinueClick = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      await cognitoLogin(data.email);
    } catch {
      // ignore — identification must not surface account-existence signals
    }
    setStep(AUTH_STEPS.PASSWORD);
  };

  return (
    // A real form with a named, autocomplete-tagged email field lets password
    // managers recognise this as the login field. Without it 1Password filled
    // the footer newsletter input instead, which closed the modal.
    <form className="mt-2.5" onSubmit={onContinueClick}>
      <input
        className="h-12 w-full rounded border border-gray-700/10 px-3 text-gray-700 outline-1 outline-gray-700 placeholder:text-gray-700/50"
        placeholder={t`Enter your email...`}
        type="email"
        name="email"
        autoComplete="username"
        value={data.email}
        onChange={(e) => setData({ ...data, email: e.target.value })}
      />

      <CtaButton
        type="submit"
        className="mt-2 !h-12 w-full !rounded !text-sm"
        loading={loading}
        disabled={!isValidEmail}
      >
        {t`Continue`}
      </CtaButton>
    </form>
  );
};

export default EmailStep;
